import { render, staticRenderFns } from "./SlugFieldtype.vue?vue&type=template&id=c8585b50&"
import script from "./SlugFieldtype.vue?vue&type=script&lang=js&"
export * from "./SlugFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports